import { format } from 'date-fns';

export const isMobile = (): boolean => window.innerWidth <= 920;

export const addZeroToDate = (value: string | number): string =>
  parseInt(value.toString(), 10) > 9 ? value.toString() : '0' + value;

export const formatDate = (date: string | Date): string =>
  format(new Date(date), 'dd.MM.yyyy');

export const isSafari: boolean =
  navigator.userAgent.indexOf("Safari") > -1 &&
  !(navigator.userAgent.indexOf("Chrome") > -1);

export const isFirefox: boolean = navigator.userAgent.indexOf('Firefox') > -1;
